












import Vue from "vue";
import { Component, Watch, Emit } from "vue-property-decorator";
import { translate } from "../../services/translation/translation";
import './nominee-main-page.less';
import nomineeCategories from "@/components/nominee-categories/nominee-categories.vue";
import {isNomineeMainpage} from "@/services/getNomineeData/getNomineeData";
import nomineeCategory from "@/components/nominee-category/nominee-category.vue";

@Component({
  components: {
    nomineeCategories,
    nomineeCategory
  }
})
export default class nomineeMainPage extends Vue {

  private selectedComponent :string = 'nominee-categories';
  private selectedCategory :number = -1;

  mounted() {
    this.getComponent();
  }

  getComponent(){
    if(isNomineeMainpage()){
      this.selectedComponent = 'nominee-categories';
    }else{
      this.selectedComponent = 'nominee-category';
    }
  }

  @Watch("selectCategory", {immediate: true, deep: true})
  onSelectCategory(id) {
    if (id !== undefined) {
      this.selectedCategory = id;
      this.selectedComponent = "nominee-category";
    }

  }

  trans(key) {
    return translate(key);
  }
}
